import "core-js/modules/es.array.push.js";
import { withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/no_live.png';
import _imports_1 from '../../assets/image/live.png';
const _withScopeId = n => (_pushScopeId("data-v-25d5c3af"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "prize"
};
const _hoisted_2 = {
  class: "dmbp_box"
};
const _hoisted_3 = {
  key: 0,
  class: "dmbp_user"
};
const _hoisted_4 = {
  class: "dmbp_user_l"
};
const _hoisted_5 = {
  class: "logo"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "info"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "http://77tk.tuku.fit//uploads/20221011/63452be097e1d.png"
}, null, -1));
const _hoisted_10 = {
  class: "tiems"
};
const _hoisted_11 = {
  class: "dmbp_user_r"
};
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_14 = {
  class: "dmbp_txt_tit"
};
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
  key: 2,
  class: "cont"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 3,
  class: "dmbp_other"
};
const _hoisted_19 = {
  key: 0,
  class: "next_a"
};
const _hoisted_20 = {
  class: "up"
};
const _hoisted_21 = ["href"];
const _hoisted_22 = {
  class: "next"
};
const _hoisted_23 = ["href"];
import nav_header from '@/components/nav_header.vue';
import { article_detail, add_follow, cancel_follow, article_like, comment_list, comment_add, article_coll, siba_comment } from '@/util/http.js';
import priz_result from '@/components/priz_result.vue';
import comment from '@/components/comment.vue';
import swipers from '@/components/swipers.vue';
import otherTail from '@/components/otherTail.vue';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import axios from 'axios';

import { useRoute, useRouter } from 'vue-router';
import { ref, reactive, onMounted } from 'vue';
export default {
  __name: 'article',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    let showss = ref(false);
    let uindex = ref(); //是否关注
    let uid = ref();
    let ids = ref();
    let islike = ref();
    let commentList = ref();
    let forumData = ref({
      user: {
        avatar: '',
        nickname: ''
      }
    });
    let dmbpOther = reactive([{
      name: '评论',
      num: '0',
      src: require('@/assets/image/commont.png')
    }, {
      name: '赞',
      num: '0',
      src: require('@/assets/image/zan.png')
    }, {
      name: '关注',
      num: '0',
      src: require('@/assets/image/love.png')
    }, {
      name: ' ',
      num: '0',
      src: require('@/assets/image/look.png')
    }, {
      name: '收藏',
      num: '0',
      src: require('@/assets/image/wujiaoxin.png')
    }]);
    let dmbpOthers = reactive([{
      name: '评论',
      num: '0',
      src: require('@/assets/image/commont.png')
    }, {
      name: '赞',
      num: '0',
      src: require('@/assets/image/zan.png')
    }, {
      name: ' ',
      num: '0',
      src: require('@/assets/image/look.png')
    }]);
    let types = ref('');
    onMounted(() => {
      let id = route.params.id;
      let type = route.params.type;
      types.value = type;
      ids.value = id;
      if (type == 1) {
        artinfoFun(id);
        commentCont(id);
        siba_comments(id);
      } else if (type == '挂牌') {
        gpinfoFun(id);
      } else {
        detail(id);
        commentCont(id);
      }
    });
    let history = data => {
      router.push({
        path: `/articleRecord/${data}`
      });
    };
    let detail = url => {
      article_detail({}, url).then(res => {
        let data = res.data;
        uindex.value = data.is_follow;
        dmbpOther[1].num = data.good_count;
        dmbpOther[3].num = data.browse.num;
        dmbpOther[2].num = data.fans_count;
        dmbpOther[4].num = data.fans_count;
        if (data.is_like) {
          dmbpOther[1].src = require('@/assets/image/on_zan.png');
        } else {
          dmbpOther[1].src = require('@/assets/image/zan.png');
        }
        if (data.is_follow) {
          dmbpOther[2].src = require('@/assets/image/live.png');
        } else {
          dmbpOther[2].src = require('@/assets/image/love.png');
        }
        if (data.is_store) {
          dmbpOther[4].src = require('@/assets/image/heiwijioaxin.png');
        } else {
          dmbpOther[4].src = require('@/assets/image/wujiaoxin.png');
        }
        uid.value = data.uid;
        islike.value = data.is_like;
        forumData.value = data;
      });
    };
    let follow = url => {
      //关注
      if (uindex.value) {
        cancel_follow({}, url).then(res => {
          showToast(res.message);
          if (res.message != "用户未登录或已过期") {
            uindex.value = false;
            dmbpOther[2].src = require('@/assets/image/love.png');
          } else {
            showss.value = true;
          }
        });
      } else {
        add_follow({}, url).then(res => {
          showToast(res.message);
          if (res.message != "用户未登录或已过期") {
            uindex.value = true;
            dmbpOther[2].src = require('@/assets/image/live.png');
          } else {
            showss.value = true;
          }
        });
      }
    };
    let infoFn = data => {
      if (data.name == '关注') {
        follow(forumData.value.uid);
      } else if (data.name == '赞') {
        if (forumData.value.is_like) {
          showToast('您已赞过该文章了');
          return false;
        }
        if (types.value != 0) {
          article_like({
            type: 4,
            state: 1
          }, ids.value).then(res => {
            if (res.code == '320') {
              showss.value = true;
              return false;
            }
            islike.value = 1;
            dmbpOther[1].src = require('@/assets/image/on_zan.png');
            if (res.message != "您已赞过") {
              dmbpOther[1].num = parseInt(dmbpOther[1].num + 1);
            }
          });
        } else {
          article_like({
            type: 1,
            state: 1
          }, ids.value).then(res => {
            if (res.code == '320') {
              showss.value = true;
              return false;
            }
            islike.value = 1;
            dmbpOther[1].src = require('@/assets/image/on_zan.png');
            if (res.message != "您已赞过") {
              dmbpOther[1].num = parseInt(dmbpOther[1].num + 1);
            }
          });
        }
      } else if (data.name == '收藏') {
        if (forumData.value.is_store) {
          showToast('您已收藏过该文章了');
          return false;
        }
        dmbpOther[4].src = require('@/assets/image/heiwijioaxin.png');
        article_coll({
          type: 1
        }, ids.value).then(res => {
          if (res.code == '320') {
            showss.value = true;
            return false;
          }
          dmbpOther[4].num = parseInt(dmbpOther[4].num + 1);
        });
      }
    };
    let siba_comments = id => {
      siba_comment({
        id: id
      }).then(res => {
        console.log(res);
        let data = res.data;
        dmbpOthers[2].num = data.browse;
        dmbpOthers[1].num = data.like;
        if (data.is_like) {
          dmbpOthers[1].src = require('@/assets/image/on_zan.png');
        } else {
          dmbpOthers[1].src = require('@/assets/image/zan.png');
        }
      });
      dmbpOther = dmbpOthers;
    };
    const loading = ref(true);
    const finished = ref(false);
    let page = ref(1);
    const onLoad = () => {
      page.value++;
      commentCont(ids.value, page.value);
    };
    let commentCont = (id, page) => {
      //评论列表
      if (types.value != 0) {
        comment_list({
          id: id,
          type: 4,
          page: page
        }).then(res => {
          dmbpOther[0].num = res.data.total;
          let datas = res.data.data;
          if (datas.length == 0) {
            finished.value = true;
          } else {
            loading.value = false;
            commentList.value.push(...datas);
          }
        });
      } else {
        comment_list({
          id: id,
          type: 1,
          page: page
        }).then(res => {
          dmbpOther[0].num = res.data.total;
          let datas = res.data.data;
          if (datas.length == 0) {
            finished.value = true;
          } else {
            loading.value = false;
            commentList.value.push(...datas);
          }
        });
      }
    };
    let commentadd = (content, uid, id, url) => {
      //添加评论
      if (types.value != 0) {
        comment_add({
          content: content,
          type: 4,
          level_uid: uid,
          level_id: id
        }, url).then(res => {
          if (res.code == '320') {
            showss.value = true;
          }
          showToast(res.message);
          commentCont(ids.value);
          activeIndexs.value = false;
        });
      } else {
        comment_add({
          content: content,
          type: 1,
          level_uid: uid,
          level_id: id
        }, url).then(res => {
          if (res.code == '320') {
            showss.value = true;
          }
          showToast(res.message);
          commentCont(ids.value);
          activeIndexs.value = false;
        });
      }
    };
    let activeIndexs = ref(false);
    let onSubmit = data => {
      //提交评论

      commentadd(data.content, data.level_uid, data.level_id, ids.value);
    };
    let returnUp = () => {
      activeIndexs.value = false;
    };
    let opencomment = () => {
      activeIndexs.value = true;
    };
    let commentNext = () => {
      activeIndex.value = true;
    };
    let artinfoFun = id => {
      let url = 'https://48c.zlapi8.com/api/artinfo';
      axios.post(url, {
        id: id
      }).then(res => {
        let data = res.data.data;
        forumData.value = data;
      });
    };
    let gpinfoFun = id => {
      let url = 'https://48c.zlapi8.com/api/gpinfo';
      axios.post(url, {
        id: id
      }).then(res => {
        let data = res.data.data;
        forumData.value = data;
      });
    };
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      const _component_logos = _resolveComponent("logos");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "详情"
      }, {
        more: _withCtx(() => []),
        _: 1
      }), _createVNode(swipers), _createElementVNode("div", _hoisted_1, [_createVNode(priz_result)]), _createElementVNode("div", _hoisted_2, [_unref(types) == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        src: _unref(forumData).user.avatar,
        alt: "",
        srcset: ""
      }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_unref(forumData).user.nickname), 1), _hoisted_9]), _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(forumData).create_time), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        class: "live",
        onClick: _cache[0] || (_cache[0] = $event => _unref(follow)(_unref(forumData).uid))
      }, [!_unref(uindex) ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : (_openBlock(), _createElementBlock("img", _hoisted_13))]), _createElementVNode("div", {
        class: "history",
        onClick: _cache[1] || (_cache[1] = $event => _unref(history)(_unref(forumData).uid))
      }, "历史帖子")])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", null, _toDisplayString(_unref(forumData).title), 1)]), _unref(forumData).content ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "cont",
        innerHTML: _unref(forumData).content
      }, null, 8, _hoisted_15)) : _createCommentVNode("", true), _unref(types) == '挂牌' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("img", {
        src: _unref(forumData).img,
        alt: ""
      }, null, 8, _hoisted_17), _createElementVNode("p", null, "【挂牌】：" + _toDisplayString(_unref(forumData).hdl), 1), _createElementVNode("p", null, "【四字】：" + _toDisplayString(_unref(forumData).ci), 1), _createElementVNode("p", null, "【火烧】：" + _toDisplayString(_unref(forumData).huoshao), 1), _createElementVNode("p", null, "【门数】：" + _toDisplayString(_unref(forumData).men), 1), _createElementVNode("p", null, "【六肖】：" + _toDisplayString(_unref(forumData)['6xiao']), 1), _createElementVNode("p", null, "【词目】：" + _toDisplayString(_unref(forumData).ci), 1), _createElementVNode("p", null, "【拼音】：" + _toDisplayString(_unref(forumData).pinyin), 1), _createElementVNode("p", null, "【解释】：" + _toDisplayString(_unref(forumData).jieshi), 1), _createElementVNode("p", null, "【出自】：" + _toDisplayString(_unref(forumData).chuzi), 1), _createElementVNode("p", null, "【示例】：" + _toDisplayString(_unref(forumData).shili), 1), _createElementVNode("p", null, "【语法】：" + _toDisplayString(_unref(forumData).yufa), 1)])) : _createCommentVNode("", true), _unref(types) == '0' || _unref(types) == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(otherTail, {
        navlist: _unref(dmbpOther),
        onInfoFn: _unref(infoFn)
      }, null, 8, ["navlist", "onInfoFn"])])) : _createCommentVNode("", true)]), _unref(types) == '挂牌' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
        href: '/detail/' + _unref(forumData).preid + '/挂牌'
      }, " 上一篇:" + _toDisplayString(_unref(forumData).preti), 9, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
        href: '/detail/' + _unref(forumData).nextid + '/挂牌'
      }, "下一篇:" + _toDisplayString(_unref(forumData).nextti), 9, _hoisted_23)])])) : _createCommentVNode("", true), _createVNode(_component_van_list, {
        loading: _unref(loading),
        "onUpdate:loading": _cache[2] || (_cache[2] = $event => _isRef(loading) ? loading.value = $event : null),
        finished: _unref(finished),
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_unref(types) == '0' || _unref(types) == '1' ? (_openBlock(), _createBlock(comment, {
          key: 0,
          onSubmit: _unref(onSubmit),
          onReturnUp: _unref(returnUp),
          onOpencomment: _unref(opencomment),
          onCommentNext: _unref(commentNext),
          commentList: _unref(commentList),
          activeIndexs: _unref(activeIndexs)
        }, null, 8, ["onSubmit", "onReturnUp", "onOpencomment", "onCommentNext", "commentList", "activeIndexs"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["loading", "finished"]), _createVNode(_component_logos, {
        shows: _unref(showss),
        "onUpdate:shows": _cache[3] || (_cache[3] = $event => _isRef(showss) ? showss.value = $event : showss = $event)
      }, null, 8, ["shows"])], 64);
    };
  }
};